import dayjs from "@/helpers/dayjs";
import ExcelDownload from "@/components/modal/ExcelDownload/index.vue";
import orderTab from "@/components/order/ListTab/layout.vue";
import mixinFilter from "@/mixins/mixinFilter";
import customSelect from "@/components/common/CustomSelect/layout.vue";
import mobileList from "@/components/order/MobileList/layout.vue";
import riderLocation from "@/components/modal/riderLocation/layout";
import "dayjs/locale/ko";

export default {
  metaInfo: {
    title: "주문내역"
  },
  mixins: [mixinFilter],
  components: {
    riderLocation,
    ExcelDownload,
    orderTab,
    customSelect,
    mobileList
  },
  computed: {},
  data() {
    return {
      tabStatus: "ongoing",
      totalRow: 1,
      perPageOption: "10",
      query: "",
      options: [
        { value: 10, title: "10개씩" },
        { value: 50, title: "50개씩" },
        { value: 100, title: "100개씩" }
      ],
      // Page Config 상태 값
      config: {
        query: "",
        page: 1,
        perPage: 10,
        tab: "ongoing"
      },
      modal: {
        excel: false
      },
      orders: [],
      tableOrders: [],
      orderDetailModalStatus: false,
      selectedOrderId: null,
      isLoading: false,
      riderLocationModal: {
        status: false,
        orderId: "",
        rider: "",
        pins: []
      }
    };
  },
  methods: {
    /**
     * 페이지 Config 값 및 쿼리를 변경하고 API를 호출
     * @param {{query: string, page: number, perPage:number, tab: string}} payload
     * @description handleUpdatePageConfig({page:1}) 이런식으로 사용하면 됩니다.
     */
    handleUpdatePageConfig(payload = {}) {
      this.config = {
        page: Number(payload?.page) || this.config.page,
        perPage: Number(payload?.perPage) || this.config.perPage,
        query: payload?.query || this.config.query,
        tab: payload?.tab || this.config.tab
      };

      this.handleUpdateQuery();
      this.fetchOrders();
    },
    /**
     * 라우터 쿼리를 추가하거나 변경
     */
    handleUpdateQuery() {
      this.$router.push({ query: { ...this.config } }).catch(() => {});
    },
    /**
     * 주문을 조회
     */
    async fetchOrders() {
      if (this.isLoading) return; // 이미 실행중인 경우 종료

      this.isLoading = true;
      this.tableOrders = []; // 테이블 오더 초기화
      this.orders = []; // 주문 초기화

      const { tab, perPage, page, query } = this.config;
      const path =
        tab === "ongoing" ? "orders/myOrdersOngoing" : "orders/myOrders";
      const payload = {
        perPage: perPage,
        currentPage: page,
        q: query
      };

      try {
        const { orders, total } = await this.$store.dispatch(path, payload);
        this.orders = orders;
        this.totalRow = total || 1;
        this.tableOrders = orders.map((order) => ({
          orderTime: dayjs(order.orderTime).format("YYYY-MM-DD hh:mm"),
          id: `#${order._id}`,
          applicant: "정보없음",
          notifiedPrice: order.notifiedPrice.toLocaleString() + "원",
          departure: order.pins[0].dongName,
          destination: order.pins[order.pins.length - 1].dongName,
          options: "오토바이 / 3Kg",
          status: this.$statusToKor(order.status),
          item: order.item
        }));
      } catch (e) {
        alert("서버에러가 발생하였습니다(2)");
      } finally {
        this.isLoading = false;
      }
    },
    openRiderLocationModal(order) {
      this.$set(this.riderLocationModal, "orderId", order._id);
      this.$set(this.riderLocationModal, "pins", order.pins);
      this.$set(this.riderLocationModal, "status", true);
    },

    countItems(item) {
      let count = 0;
      let result = "";

      for (const key in item) {
        const value = item[key];
        if (key !== "weight" && key !== "fragile") {
          if (key === "etc" && value !== null && value !== "") {
            count++;
            if (count >= 2) {
              return "여러개";
            }
            result = `${this.mixinsItemTitle(key)}`;
          }
          if (key !== "etc" && value > 0) {
            count++;
            if (count >= 2) {
              return "여러개";
            }
            result = `${this.mixinsItemTitle(key)} ${item[key]}개`;
          }
        }
      }

      return result;
    },
    optionsCarRequired(order) {
      if (order.options.indexOf("bike") !== -1) return false;
      return true;
    },

    async cancelOrder(orderId) {
      const c = confirm(
        "취소요청을 하시겠습니까? 배차완료 후 취소요청 시 위약금이 발생할 수 있습니다"
      );
      if (!c) return;

      try {
        const result = await this.$store.dispatch("orders/cancelOrder", {
          orderId: orderId
        });
        if (!result.success) {
          console.error(result);
          alert("에러가 발생하였습니다");
          return this.$router.go();
        }
        alert("취소가 완료되었습니다");
        return this.$router.go();
      } catch (e) {
        console.error(e);
        alert("에러가 발생하였습니다");
        return this.$router.go();
      }
    },
    openOrderDetailModal(orderId) {
      this.selectedOrderId = orderId;
      this.orderDetailModalStatus = true;
    },
    closeModal() {
      this.orderDetailModalStatus = false;
    },
    async pagination(val) {
      const totalPage = Math.ceil(this.totalRow / this.config.perPage);
      if (val == -1 && this.config.page == 1) {
        alert("첫 번째 페이지 입니다");
        return;
      }

      if (this.config.page == totalPage && val !== -1) {
        alert("마지막 페이지 입니다");
        return;
      }
      this.handleUpdatePageConfig({ page: this.config.page + val });
    },

    reorder(orderId) {
      const flag = "reorder";
      this.$router.push(`/orders/form/${orderId}/${flag}`);
    }
  },
  created() {
    const { page, perPage, query, tab } = this.$route.query;
    this.handleUpdatePageConfig({ page, perPage, query, tab });
  },
  mounted() {}
};
